<div class="nd-main-container">
    <owc-card oneCard class="nd-one-card">
        <div class="nd-content">
        <owc-component-header>
            <span class="mat-title">Notification document</span>
            <owc-switch [(ngModel)]="documentEnabled" (ngModelChange)="updateDocumentEnabled($event)" style="font-size: 16px; padding: 0px; position: relative; right: 5px;">
            Enabled
        </owc-switch>
        </owc-component-header>
<div *ngIf="!documentEnabled">
        <p style="color: red; font-style: italic; padding-left: 16px;">The notification will not have attached documents.</p>
    </div>
        <div *ngIf="documentEnabled">
            <div class="nd-search-section">
                <p>Search and select the notification in PIM.web which you want to add the notification document.</p>
                <div class="search-document-box">
                    <owc-input #inputElement variant="outlined"
                        placeholder="e.g. QN-CPS-2020-001 or Electrolyte Analyzer" [formControl]="searchDocumentControl"
                        class="nd-document-search">
                        <owc-icon slot="prefix" name="search" family="outlined" />
                    </owc-input>
                    <owc-select-dropdown [formControl]="notificationTypeFormControl" [placeholder]="'Notification type'"
                        variant="outlined" size="big" class="unique-horizontal-stepper-countries-list">
                        <owc-list-item *ngFor="let item of notificationTypeList" [value]="item.label">
                            {{ item.label }}</owc-list-item>
                    </owc-select-dropdown>
                    <owc-button [disabled]="!searchDocumentControl.value" owc-stroked-button one-secondary-button
                        (click)="onSearch()">
                        Search
                    </owc-button>
                </div>
            </div>

            <div *ngIf="!isTableShow && files.length === 0" style="padding-left: 16px;">
                <p> or upload a local document (maximum size: 15 MB): </p>

                <dl-file-upload-single [fileUploadwithCheck]="'single'"></dl-file-upload-single>
            </div>

            <div *ngIf="files.length > 0" class="ddr-reminder-section" style="padding: 16px;">
                <h4>Notification PDF</h4>
                <div class="files-list" *ngFor="let file of files; let i = index">
                    <div class="single-file">
                        <div class="info infoLink" (click)="downloadDocument(file.name)">
                            <owc-icon class="one-icons one-icons-outlined">{{file?.fileIcon}}</owc-icon>
                            <span class="file-info">
                                <span class="name">
                                    {{ file?.name }}
                                    <span class="globalTag">Global</span>
                                </span>
                                <p class="size">
                                    {{ formatBytes(file?.size) }}
                                </p>
                            </span>
                        </div>
                        <owc-icon class="one-icons one-icons-outlined" (click)="deleteFile(i,file)" style="cursor: pointer;">delete</owc-icon>
                    </div>
                </div>
            </div>
            <div class=" ddr-search-result-section" [ngStyle]="{'display':isTableShow ?'block':'none'}">
                <div class="nd-search-table-heading owc-h4 owc-subheading-1">
                    <span>Search results</span>
                    <span *ngIf="dataFlag">{{ ELEMENT_DATA.length }} results</span>
                    <span *ngIf="!dataFlag">0 results</span>
                </div>

                <owc-table *ngIf="ELEMENT_DATA.length > 0 && dataFlag" class="w-100" style="padding-left: 5px;">
                    <owc-table-header sticky>
                        <owc-table-header-cell>Document title</owc-table-header-cell>
                        <owc-table-header-cell>Version</owc-table-header-cell>
                        <owc-table-header-cell>Language</owc-table-header-cell>
                        <owc-table-header-cell>Date</owc-table-header-cell>
                        <owc-table-header-cell></owc-table-header-cell>
                    </owc-table-header>


                    <owc-table-body [style]="{ maxHeight: '400px', minHeight: '400px' }">
                        @for (item of ELEMENT_DATA; track $index) {
                        <owc-table-row>
                            <owc-table-simple-cell [title]="item.Type">{{item.Title}}</owc-table-simple-cell>
                            <owc-table-simple-cell [title]="item.VersionNumber">{{item.VersionNumber}}</owc-table-simple-cell>
                            <owc-table-simple-cell [title]="item.Language">{{item.Language[0]['IsoCode']}} </owc-table-simple-cell>

                            <owc-table-simple-cell [title]="item.ModifyDate"> {{item.ModifyDate}}</owc-table-simple-cell>
                            <owc-table-simple-cell *ngIf = "count<=1">
                                <i class="one-icons-outlined" (click)="addSearchedDocument(item)" style="cursor: pointer;">file_create</i>
                            </owc-table-simple-cell>
                        </owc-table-row>
                        }
                    </owc-table-body>
                </owc-table>
                <table disabled="isTableShow" *ngIf="ELEMENT_DATA.length == 0" style="margin-top: 16px; padding-left: 10px;"
                    class="no-data-found-table mat-table cdk-table ng-star-inserted w-100">

                    <tr class="mat-header-row cdk-header-row ng-star-inserted">
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Document title</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Version</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Language</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Date</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                        </th>
                    </tr>

                    <tr class="error-msg">

                        <td class="error-msg-td" colspan="5">

                            <owc-icon name="search" family="outlined"></owc-icon>

                            <span class="error-msg-title">
                                <B>Search error</B>
                            </span>

                            <p class="error-msg-para">
                                There was an error while running your search. Please try again.
                            </p>

                        </td>

                    </tr>
                </table>

                <table disabled="isTableShow" *ngIf="!dataFlag"
                    class="no-data-found-table mat-table cdk-table ng-star-inserted w-100">

                    <tr class="mat-header-row cdk-header-row ng-star-inserted">
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Document title</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Version</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Language</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                            Date</th>
                        <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                        </th>
                    </tr>

                    <tr class="error-msg">

                        <td class="error-msg-td" colspan="5">

                            <p class="error-msg-para">
                                No document found for this search text and document type.
                            </p>

                        </td>

                    </tr>
                </table>
                <owc-pagination *ngIf="ELEMENT_DATA.length > 0 && dataFlag" [pageSizeOptions]="[5, 10, 20]"
                    aria-label="Select page of periodic elements"></owc-pagination>


            </div>

        </div>
        </div>
    </owc-card>
</div>